import React from 'react';
import { Tab } from 'react-bootstrap';
import { ContentMessage } from 'axway-react-ui';
import NodeConfigField from './NodeConfigField';

/**
 * Renders an outputs `Tab` containing a single `NodeConfigField` generated
 * from a JSON schema that represents the requestSchema (from a flow-trigger).
 *
 * @param {object} options - The options.
 * @param {string} [options.title] - The title of the tab.
 * @param {object} options.schema - A JSON schema.
 * @param {string} [options.message] - The message to display if there is no
 * data.
 * @returns {Tab} A tab with output properties.
 */
function renderTriggerOutputsTab(options) {
	const {
		title,
		schema,
		description,
		emptyMessage
	} = options;

	if (!schema) {
		return (
			<Tab
				eventKey="outputs"
				title={title}
			>
				<ContentMessage
					detail={emptyMessage}
					imgClass="gg icon-GG-empty-list"
					className="sm empty"
					inlineContent
				/>
			</Tab>
		);
	}

	return (
		<Tab
			eventKey="outputs"
			title={title}
		>
			<div className="nodeconfigfield form-group">
				{description}
			</div>
			<NodeConfigField
				id="requestSchema"
				type="object"
				name={schema.title}
				description={schema.description}
				valueType="selector"
				value="$.request"
				readOnly
				required
				schema={schema}
				selectors={[]}
			/>
		</Tab>
	);
}

export default renderTriggerOutputsTab;
